import type { CompanySettingsInput, UserCreateInput, UserUpdateInput, Role } from '@oficina/shared';
import { api } from '@/lib/api';
import type { CompanySettings, DashboardSummary, ImportReport, User } from '@/types/api';

export const dashboardService = {
  summary: () => api.get<DashboardSummary>('/dashboard'),
};

export const usersService = {
  list: (includeInactive = true) => api.get<User[]>('/users', { includeInactive }),
  technicians: () => api.get<{ id: string; name: string; role: Role }[]>('/users/technicians'),
  create: (input: UserCreateInput) => api.post<User>('/users', input),
  update: (id: string, input: UserUpdateInput) => api.patch<User>(`/users/${id}`, input),
};

export const settingsService = {
  get: () => api.get<CompanySettings>('/settings/company'),
  update: (input: CompanySettingsInput) => api.put<CompanySettings>('/settings/company', input),
  uploadLogo: (file: File) => {
    const form = new FormData();
    form.append('file', file);
    return api.upload<CompanySettings>('/settings/company/logo', form);
  },
  removeLogo: () => api.delete<CompanySettings>('/settings/company/logo'),
};

export const importService = {
  legacy: (file: File) => {
    const form = new FormData();
    form.append('file', file);
    return api.upload<ImportReport>('/admin/import/legacy', form);
  },
};
